import {Component, OnInit, AfterViewInit, Input, ElementRef, ViewChild, Injector} from "@angular/core";
import {FormGroup, FormControl} from "@angular/forms";
import {NgbModalOptions, NgbModal, NgbModalRef, NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Workspace} from "../../../model/workspace.data";
import {AppComponentBase} from "../../../services/AppComponentBase";
import {IParameters} from "../../../interfaces/IParameters";
import * as $ from "jquery";

import {AgGridModule} from "ag-grid-angular";
import {GridOptions, GridApi, ColumnApi, ColDef} from "ag-grid";
import {AgGridNg2} from "ag-grid-angular";
import {strategyCellRendererComponent} from "../../../renderers/strategyCellRendererComponent.component";
import {GlobalGridModeService} from "../../../services/globalGridMode/globalGridMode.service";
import {callNextAsync} from "../../../services/BaseService";
import {ScannerPrimarySearchList} from "../../scanner/interfaces/scanner.enums";
import {IchWizardpointType, IRSIScanRule, IBBandsScanRule, IEMAScanRule, IMACDScanRule, IEntrySignalsScanData, ITIScanRule} from "../../scanner/interfaces/scanner.interfaces";

@Component({
    selector: "saveScanModal",
    template: require('./saveScan.component.html'),
    styles: [require('./saveScan.component.css'), require('../SavedStrategiesModal/SavedStrategiesModal.component.css')]
})
export class saveScanComponent extends AppComponentBase implements OnInit, AfterViewInit {


    constructor(
        injector: Injector,
        public activeModal: NgbActiveModal,
        private globalGridModeService: GlobalGridModeService,
        private ngbModalService: NgbModal
    ) {
        super(injector);

        if(this.workspace.selectedSavedScan != "" && this.workspace.canSelectedSavedScanUpdate) {
            this.toUpdate = true;
        }

    }


    public get scanToUpdate() {
        return this.workspace.savedScansOnePool.find(v => v.key == this.workspace.selectedSavedScan)
    }






    private _toUpdate: boolean = false;
    public get toUpdate(): boolean {
        return this._toUpdate;
    }
    public set toUpdate(value: boolean) {
        this._toUpdate = value;
    }


    ngOnInit() {}
    ngAfterViewInit(): void {

    }

    initData(v: any) {

    }

    private _newSavedScanName: string = "";
    public get newSavedScanName(): string {
        return this._newSavedScanName;
    }
    public set newSavedScanName(value: string) {
        this._newSavedScanName = value;
    }

    public saveNewSavedScan(activeModal: NgbActiveModal) {

        if(this.isNarrow) {
            //   this.saveDataNarrow()
        }

        if(!this.isNarrow) {
            //    this.saveData()
        }

        this.saveFullScanParams();

        this.workspace.addSavedScan();

        activeModal.dismiss();

    }




    public saveFullScanParams() {

        let currentKey = `${ new Date().getTime() }.${ Math.random() }`;

        let saveObj = {
            key: currentKey,
            savedData: this.getPrimarySaveData(currentKey),
            savedDataSecondary: this.getSecondaryData(currentKey),

        }

        this.workspace.savedScansOnePool.push(saveObj);
        this.workspace.selectedSavedScan = currentKey
    }


    public updateSavedScan(activeModal: NgbActiveModal) {
        if(this.scanToUpdate) {

            //    if(this.workspace.selectedPrimaryScanner != ScannerPrimarySearchList.SCANNER_CHARTING)
            //    {
            this.scanToUpdate.savedData = {
                key: this.scanToUpdate.key,
                name: this.scanToUpdate.savedData.name,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.selectedPrimaryScanner,
                period: this.workspace.scannerSearch_period,
                study: this.workspace.scannerSearch_chartingstudy,
                rule: this.workspace.scannerCurrentRule
            }

            this.scanToUpdate.savedDataSecondary = {
                key: this.scanToUpdate.key,
                name: this.scanToUpdate.savedData.name,
                market: this.workspace.scannerSearch_market,
                primary: <any> this.workspace.narrowScanComponent,
                period: this.workspace.scannerSearch_Narrow_period,
                study: this.workspace.scannerSearch_Narrow_chartingstudy,
                rule: this.workspace.scannerCurrentRule_Narrow
            }
        }



        this.workspace.addSavedScan();
        this.workspace.canSelectedSavedScanUpdate = false;
        activeModal.dismiss();

        //  }
    }

    public getPrimarySaveData(currentKey: string) {

        let savedData: any = {};

        if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_WIZARD) {

            savedData = {
                key: currentKey,
                name: this.newSavedScanName,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.selectedPrimaryScanner,
                period: this.workspace.scannerSearch_period,
                rule: <IchWizardpointType> this.workspace.scannerCurrentRule
            }


        }

        if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_CHARTING) {



            savedData = {
                key: currentKey,
                name: this.newSavedScanName,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.selectedPrimaryScanner,
                period: this.workspace.scannerSearch_period,
                study: this.workspace.scannerSearch_chartingstudy,
                rule: <(IRSIScanRule | IBBandsScanRule | IEMAScanRule | IMACDScanRule)> this.workspace.scannerCurrentRule
            }



        }

        if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS) {

            savedData = {
                key: currentKey,
                name: this.newSavedScanName,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.selectedPrimaryScanner,
                rule: <IEntrySignalsScanData> this.workspace.scannerCurrentRule
            }



        }

        if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_TIWIZARD) {


            savedData = {
                key: currentKey,
                name: this.newSavedScanName,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.selectedPrimaryScanner,
                period: this.workspace.scannerSearch_period,
                rule: <ITIScanRule> this.workspace.scannerCurrentRule
            }



        }
        return JSON.parse(JSON.stringify(savedData));
        //  this.workspace.selectedSavedScan = currentKey;
    }


    public getSecondaryData(currentKey: string) {
        let savedData: any = {};
        if(this.workspace.narrowScanComponent == ScannerPrimarySearchList.SCANNER_WIZARD) {

            // if(this.workspace.savedScans.wizard==undefined)
            // {
            //   this.workspace.savedScans.wizard = [];
            // }


            savedData = {
                key: currentKey,
                name: this.newSavedScanName,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.narrowScanComponent,
                period: this.workspace.scannerSearch_Narrow_period,
                rule: <IchWizardpointType> this.workspace.scannerCurrentRule_Narrow
            }
        }

        if(this.workspace.narrowScanComponent == ScannerPrimarySearchList.SCANNER_CHARTING) {

            // if(this.workspace.savedScans.charting==undefined)
            // {
            //   this.workspace.savedScans.charting = [];
            // }


            savedData = {
                key: currentKey,
                name: this.newSavedScanName,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.narrowScanComponent,
                period: this.workspace.scannerSearch_Narrow_period,
                study: this.workspace.scannerSearch_Narrow_chartingstudy,
                rule: <(IRSIScanRule | IBBandsScanRule | IEMAScanRule | IMACDScanRule)> this.workspace.scannerCurrentRule_Narrow
            }
        }

        if(this.workspace.narrowScanComponent == ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS) {

            // if(this.workspace.savedScans.entrysignals==undefined)
            // {
            //   this.workspace.savedScans.entrysignals = [];
            // }


            savedData = {
                key: currentKey,
                name: this.newSavedScanName,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.narrowScanComponent,
                rule: <IEntrySignalsScanData> this.workspace.scannerCurrentRule_Narrow
            }
        }



        if(this.workspace.narrowScanComponent == ScannerPrimarySearchList.SCANNER_TIWIZARD) {

            // if(this.workspace.savedScans.tiWizard==undefined)
            // {
            //   this.workspace.savedScans.tiWizard = [];
            // }


            savedData = {
                key: currentKey,
                name: this.newSavedScanName,
                market: this.workspace.scannerSearch_market,
                primary: this.workspace.narrowScanComponent,
                period: this.workspace.scannerSearch_Narrow_period,
                rule: <ITIScanRule> this.workspace.scannerCurrentRule_Narrow
            }


        }

        return JSON.parse(JSON.stringify(savedData));
    }


    private _isNarrow: boolean = false;
    public get isNarrow(): boolean {
        return this._isNarrow;
    }
    public set isNarrow(value: boolean) {
        this._isNarrow = value;
    }

    /**OLD */
    public saveData() {

        let currentKey = "";
        if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_WIZARD) {
            currentKey = `${ new Date().getTime() }.${ Math.random() }`;
            this.workspace.savedScansOnePool.push({
                key: currentKey,
                savedData: {
                    key: currentKey,
                    name: this.newSavedScanName,
                    market: this.workspace.scannerSearch_market,
                    primary: this.workspace.selectedPrimaryScanner,
                    period: this.workspace.scannerSearch_period,
                    rule: <IchWizardpointType> this.workspace.scannerCurrentRule
                }
            })

        }

        if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_CHARTING) {


            currentKey = `${ new Date().getTime() }.${ Math.random() }`;
            this.workspace.savedScansOnePool.push({
                key: currentKey,
                savedData: {
                    key: currentKey,
                    name: this.newSavedScanName,
                    market: this.workspace.scannerSearch_market,
                    primary: this.workspace.selectedPrimaryScanner,
                    period: this.workspace.scannerSearch_period,
                    study: this.workspace.scannerSearch_chartingstudy,
                    rule: <(IRSIScanRule | IBBandsScanRule | IEMAScanRule | IMACDScanRule)> this.workspace.scannerCurrentRule
                }
            })


        }

        if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS) {


            currentKey = `${ new Date().getTime() }.${ Math.random() }`;
            this.workspace.savedScansOnePool.push({
                key: currentKey,
                savedData: {
                    key: currentKey,
                    name: this.newSavedScanName,
                    market: this.workspace.scannerSearch_market,
                    primary: this.workspace.selectedPrimaryScanner,
                    rule: <IEntrySignalsScanData> this.workspace.scannerCurrentRule
                }
            })


        }



        if(this.workspace.selectedPrimaryScanner == ScannerPrimarySearchList.SCANNER_TIWIZARD) {

            currentKey = `${ new Date().getTime() }.${ Math.random() }`;
            this.workspace.savedScansOnePool.push({
                key: currentKey,
                savedData: {
                    key: currentKey,
                    name: this.newSavedScanName,
                    market: this.workspace.scannerSearch_market,
                    primary: this.workspace.selectedPrimaryScanner,
                    period: this.workspace.scannerSearch_period,
                    rule: <ITIScanRule> this.workspace.scannerCurrentRule
                }
            })


        }

        this.workspace.selectedSavedScan = currentKey;
    }

    public saveDataNarrow() {
        let currentKey = `${ new Date().getTime() }.${ Math.random() }`;
        if(this.workspace.selectedPrimaryScanner_Narrow == ScannerPrimarySearchList.SCANNER_WIZARD) {

            // if(this.workspace.savedScans.wizard==undefined)
            // {
            //   this.workspace.savedScans.wizard = [];
            // }

            this.workspace.savedScansOnePool.push({
                key: currentKey,
                savedData: {
                    key: currentKey,
                    name: this.newSavedScanName,
                    market: this.workspace.scannerSearch_market,
                    primary: this.workspace.selectedPrimaryScanner_Narrow,
                    period: this.workspace.scannerSearch_Narrow_period,
                    rule: <IchWizardpointType> this.workspace.scannerCurrentRule_Narrow
                }
            });
        }

        if(this.workspace.selectedPrimaryScanner_Narrow == ScannerPrimarySearchList.SCANNER_CHARTING) {

            // if(this.workspace.savedScans.charting==undefined)
            // {
            //   this.workspace.savedScans.charting = [];
            // }

            this.workspace.savedScansOnePool.push({
                key: currentKey,
                savedData: {
                    key: currentKey,
                    name: this.newSavedScanName,
                    market: this.workspace.scannerSearch_market,
                    primary: this.workspace.selectedPrimaryScanner_Narrow,
                    period: this.workspace.scannerSearch_Narrow_period,
                    study: this.workspace.scannerSearch_Narrow_chartingstudy,
                    rule: <(IRSIScanRule | IBBandsScanRule | IEMAScanRule | IMACDScanRule)> this.workspace.scannerCurrentRule_Narrow
                }
            });
        }

        if(this.workspace.selectedPrimaryScanner_Narrow == ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS) {

            // if(this.workspace.savedScans.entrysignals==undefined)
            // {
            //   this.workspace.savedScans.entrysignals = [];
            // }

            this.workspace.savedScansOnePool.push({
                key: currentKey,
                savedData: {
                    key: currentKey,
                    name: this.newSavedScanName,
                    market: this.workspace.scannerSearch_market,
                    primary: this.workspace.selectedPrimaryScanner_Narrow,
                    rule: <IEntrySignalsScanData> this.workspace.scannerCurrentRule_Narrow
                }
            });
        }



        if(this.workspace.selectedPrimaryScanner_Narrow == ScannerPrimarySearchList.SCANNER_TIWIZARD) {

            // if(this.workspace.savedScans.tiWizard==undefined)
            // {
            //   this.workspace.savedScans.tiWizard = [];
            // }

            this.workspace.savedScansOnePool.push({
                key: currentKey,
                savedData: {
                    key: currentKey,
                    name: this.newSavedScanName,
                    market: this.workspace.scannerSearch_market,
                    primary: this.workspace.selectedPrimaryScanner_Narrow,
                    period: this.workspace.scannerSearch_Narrow_period,
                    rule: <ITIScanRule> this.workspace.scannerCurrentRule_Narrow
                }
            });


        }
    }











}


export function ShowsaveScanComponentModal(modalService: NgbModal, narrow: boolean = false) {
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: "dark-modal",
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(saveScanComponent, opt);

    let modal = (<saveScanComponent> m.componentInstance);

    modal.isNarrow = narrow;

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

